import React from 'react';

const AgencyFormContext = React.createContext(null);

export default AgencyFormContext;
